import React from 'react'
import BlockFeatureCard from '@berlitz/blocks/lib/BlockFeatureCard'
import { getBackgroundColor, findSpansAndLinks, wrapParagraph} from '../../functions/utils'
import { SliceWrapper } from '../SliceWrapper'
const SliceFeatureCard = ({ primary, pageLinks }) => {
  const callToAction =
    primary.one_page_link || primary.feature_card_call_to_action.url
    const darkBackgrounds = ['#004FEF', 'purple', '#1D1D1D']
    const hasDarkBackground = darkBackgrounds.includes(getBackgroundColor(primary.section_background_color))
    const processedParagraph = findSpansAndLinks(primary.feature_card_content?.raw, pageLinks);

    return (
    <SliceWrapper
      backgroundColor={getBackgroundColor(primary.section_background_color)} hasDarkBackground={hasDarkBackground}
    >
      <BlockFeatureCard
        title={primary.feature_card_title}
        backgroundColor={getBackgroundColor(primary.section_background_color)}
        content={wrapParagraph(processedParagraph.map(p => p.text).join(''))} 
        imageSrc={primary?.feature_card_image?.url}
        youtubeVideoId={primary.youtube_video_id}
        reverse={primary.flipped}
        button={
          callToAction && primary.feature_card_call_to_action_text
            ? {
                as: 'a',
                href: callToAction,
                text: primary.feature_card_call_to_action_text,
              }
            : {}
        }
      />
    </SliceWrapper>
  )
}

export default SliceFeatureCard
